import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

import { FinalizeQuoteTaskAttemptSchema } from "./finalize-quote";

export const SowChangeFinalizeQuoteTaskAttemptSchema = FinalizeQuoteTaskAttemptSchema.extend({
  type: z.literal(TaskType.SOW_CHANGE_FINALIZE_QUOTE),
});
